import { getUnmaskedValue } from './MaskUtils';
import moment from 'moment';

const cpfsInvalidos = [
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999'
];

export const validaCPF = (cpf: string | number) => {
  cpf = getUnmaskedValue(cpf);
  if (cpf.length < 11 || cpfsInvalidos.indexOf(cpf) > -1) return false;
  // PRIMEIRO DIGITO
  let primeiraSoma = 0;
  for (let i = 0; i < 9; i++) {
    primeiraSoma += (10 - i) * parseInt(cpf[i]);
  }
  let primeiroResto = (primeiraSoma * 10) % 11;
  if (primeiroResto >= 10) primeiroResto = 0;
  if (primeiroResto !== parseInt(cpf[9])) return false;
  // SEGUNDO DIGITO
  let segundaSoma = 0;
  for (let i = 0; i < 10; i++) {
    segundaSoma += (11 - i) * parseInt(cpf[i]);
  }
  let segundoResto = (segundaSoma * 10) % 11;
  if (segundoResto >= 10) segundoResto = 0;
  if (segundoResto !== parseInt(cpf[10])) return false;
  return true;
};

export const validaTelefone = (telefone: string | number) => {
  telefone = getUnmaskedValue(telefone);
  if (telefone.length < 10 || telefone.length > 11) {
    return false;
  }
  return true;
};

export const validaData = (data: string) => {
  if (!String(data).match(/\d{2}\/{1}\d{2}\/{1}\d{4}/)) return false;
  const mData = moment(data, 'DD/MM/YYYY');
  if (!mData.isValid()) return false;
  return true;
};

export const validaDataNascimento = (data: string) => {
  if (!validaData(data)) return false;
  const hoje = moment();
  const mData = moment(data, 'DD/MM/YYYY');
  if (mData.isAfter(hoje)) return false;
  return true;
};

export const validaEmail = (email: string) => {
  const confereEmail =
    /^(\w)+((\.|_|-){1}(\w)+)*(@){1}(\w+)((\.|_|-){1}\w+)+$/gi;
  if (!String(email).match(confereEmail)) {
    return false;
  }
  return true;
};

export const allIsTrue = (validations: boolean[]) => {
  return validations.every(
    (item) => typeof item === 'boolean' && item === true
  );
};
export const someIsTrue = (validations: boolean[]) => !allIsFalse(validations);
export const allIsFalse = (validations: boolean[]) => {
  return validations.every(
    (item) => typeof item === 'boolean' && item === false
  );
};
export const someIsFalse = (validations: boolean[]) => !allIsTrue(validations);

export const validaHexadecimalColor = (hex: string) => {
  const str = String(hex).replace(/\W/g, '');
  if (str.length !== 3 && str.length !== 6) return false;
  return str.match(/([a-fA-F0-9]{6})/);
};
